module.exports = __webpack_public_path__ + "Flag-392.65e3d5cfeb3da97f820d173bd09145b7.svg";